import { Component, OnInit, QueryList, ViewChildren, AfterViewChecked, ElementRef, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { Grid9Position } from 'src/app/types/grid9-position';

@Component({
	selector: 'app-grid9-position',
	templateUrl: './grid9-position.component.html',
	styleUrls: ['./grid9-position.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush

})
export class Grid9PositionComponent implements AfterViewChecked {

	public pos: Grid9Position = 'cc';

	private ready = false;
	@ViewChildren(IconButtonComponent) buttons: QueryList<IconButtonComponent>;
	constructor(private domNode: ElementRef, private changes: ChangeDetectorRef) { }
	@Input()
	set position(pos: Grid9Position) {
		if(!pos) {
			pos = 'cc';
			this.positionChange.emit(this.position);
		}
		this.pos = pos;
		this.changes.detectChanges();
	}
	get position() {
		return this.pos;
	}
	@Output() positionChange = new EventEmitter<Grid9Position>();

	ngAfterViewChecked(): void {
		this.ready = true;
		// this.HandleButton(this.position);
		this.changes.detectChanges();
	}

	set value(position: Grid9Position) {
		this.HandleButton(position);
	}
	get value(): Grid9Position {
		return this.position;
	}

	HandleButton(val: Grid9Position) {
		this.position = val;
		this.changes.detectChanges();
		this.positionChange.emit(this.position);
		if (!this.ready) { return; }
		/*this.buttons.forEach((button: IconButtonComponent) => {
			button.Toggle(button.function === 'position-' + this.position);
			if (button.function === 'position-' + this.position) {
			}
		});
		this.positionChange.emit(this.position);
		*/
	}
}
